// THIS WILL REPLACE 2 or 2+ WHITE SPACES FROM STRING
const rmSpaceUTL = (string) => string.replace(/\s{2,}/g, ' ').trim();

export default rmSpaceUTL;
